import { render, staticRenderFns } from "./Advertise.vue?vue&type=template&id=0bab9714&scoped=true&"
import script from "./Advertise.vue?vue&type=script&lang=js&"
export * from "./Advertise.vue?vue&type=script&lang=js&"
import style0 from "./Advertise.vue?vue&type=style&index=0&id=0bab9714&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bab9714",
  null
  
)

export default component.exports